import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { XCircle } from 'lucide-react';
export function StorySection() {
  return <section className="py-24 px-4 bg-brand-slate relative border-y border-brand-charcoal" data-id="element-178">
      <div className="max-w-3xl mx-auto" data-id="element-179">
        {/* The Hook */}
        <FadeIn data-id="element-180">
          <div className="prose prose-lg prose-invert mx-auto" data-id="element-181">
            <p className="text-xl md:text-2xl leading-relaxed text-brand-cream font-playfair italic mb-8" data-id="element-182">
              "Estás en la cocina. Le pides algo sencillo. Él ni siquiera
              levanta la vista del teléfono. Insistes, y lo que sigue es el
              mismo guion de siempre: un portazo, un suspiro de desprecio o un
              grito que te deja temblando de rabia e impotencia."
            </p>
            <p className="text-lg text-brand-gray mb-16" data-id="element-183">
              Cierras la puerta del baño y lloras en silencio. No porque seas
              una mala madre, sino porque te sientes invisible en tu propia
              casa. Amas a tu hijo, pero has empezado a temer el momento en que
              llega del colegio.
            </p>
          </div>
        </FadeIn>

        {/* The Problem */}
        <FadeIn delay={0.2} data-id="element-184">
          <div className="bg-brand-navy/50 p-8 md:p-12 rounded-2xl border border-brand-charcoal mb-16" data-id="element-185">
            <h3 className="text-2xl md:text-3xl font-bold mb-6 text-brand-cream" data-id="element-186">
              El problema no es tu hijo.
            </h3>
            <p className="text-lg mb-6" data-id="element-187">
              El problema es que estás intentando razonar con un cerebro que,
              biológicamente, tiene el área de la lógica{' '}
              <span className="text-brand-gold font-semibold" data-id="element-188">
                "bajo construcción"
              </span>
              .
            </p>
            <p className="text-lg" data-id="element-189">
              Cada vez que das un sermón, ruegas por respeto o amenazas con
              castigos que no cumples, le estás entregando el control remoto de
              tus emociones. Estás agotada de caminar sobre cáscaras de huevo,
              midiendo cada palabra para no estallar una guerra mundial.
            </p>
          </div>
        </FadeIn>

        {/* Why what you tried didn't work */}
        <FadeIn delay={0.3} data-id="element-190">
          <h3 className="text-2xl md:text-3xl font-bold mb-8 text-center" data-id="element-191">
            Por qué lo que has intentado{' '}
            <span className="text-red-400" data-id="element-192">no funciona</span>:
          </h3>

          <div className="space-y-6" data-id="element-193">
            {[{
            title: 'El "Sermón de los 5 minutos"',
            desc: 'Solo logra que él desconecte su cerebro al décimo segundo.'
          }, {
            title: 'Las amenazas vacías',
            desc: 'Le enseñan que tu palabra no tiene peso real.'
          }, {
            title: 'Rogar por amor o respeto',
            desc: 'Genera culpa, y la culpa en un adolescente se convierte en más ira.'
          }, {
            title: 'Gritar',
            desc: 'Te rebaja a su nivel de inmadurez, eliminando tu posición de autoridad.'
          }].map((item, index) => <FadeIn key={index} delay={0.1 * index} direction="left" data-id="element-194">
                <div className="flex items-start gap-4 bg-brand-navy/30 p-6 rounded-xl border border-brand-charcoal/50" data-id="element-195">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-196" />
                  <div data-id="element-197">
                    <h4 className="text-xl font-bold text-brand-cream mb-2" data-id="element-198">
                      {item.title}
                    </h4>
                    <p className="text-brand-gray" data-id="element-199">{item.desc}</p>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}